import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LangProvider } from "./i18n/LangContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Purchasing from "./components/Purchasing";
import Partners from "./components/Partners";
import Services from "./components/Services";
import CatalogDownload from "./components/CatalogDownload";
import Method from "./components/Method";
import Benefits from "./components/Benefits";
import Sectors from "./components/Sectors";
import About from "./components/About";
import CaseStudies from "./components/CaseStudies";
import Careers from "./components/Careers";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import { getToken } from "./admin/auth";

const HomePage = () => (
    <main data-testid="home-page" className="bg-white min-h-screen">
        <Header />
        <Hero />
        <Purchasing />
        <Partners />
        <Services />
        <CatalogDownload />
        <Method />
        <Benefits />
        <Sectors />
        <About />
        <CaseStudies />
        <Careers />
        <Contact />
        <Footer />
        <WhatsAppFloat />
    </main>
);

const RequireAdmin = ({ children }) =>
    getToken() ? children : <Navigate to="/admin" replace />;

function App() {
    return (
        <LangProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/admin" element={<AdminLogin />} />
                    <Route
                        path="/admin/dashboard"
                        element={
                            <RequireAdmin>
                                <AdminDashboard />
                            </RequireAdmin>
                        }
                    />
                    <Route path="*" element={<HomePage />} />
                </Routes>
            </BrowserRouter>
        </LangProvider>
    );
}

export default App;
